export default "__VITE_ASSET__6f977b2e__"